import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { CTAButton } from 'shared-components/buttons/cta-button';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

class ConfirmDeclineOfferModal extends React.Component {
  constructor (props) {
    super(props);

    this.modalBody = this.modalBody.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleMessageHostClick = this.handleMessageHostClick.bind(this);
    this.handleDeclineOfferClick = this.handleDeclineOfferClick.bind(this);
  }

  componentDidMount () {
    const { iosWebView, scrollTopIOS } = this.props;

    if (iosWebView) {
      scrollTopIOS();
    }
  }

  handleMessageHostClick () {
    const { bookingId, iosWebView, closeIOSModal } = this.props;

    if (iosWebView) {
      return closeIOSModal();
    }

    this.context.router.push(`/inbox/${bookingId}`);
    this.props.toggleModal('');
  }

  handleDeclineOfferClick () {
    this.props.toggleModal('declineOfferModal');
  }

  closeModal () {
    this.props.toggleModal('');
  }

  modalBody () {
    return (
      <div className="ConfirmDeclineOfferModal col-xs-12" style={{ paddingBottom: 40 }}>
        <p>
          <FormattedMessage
            id='inbox_review_offer.confirm_decline_offer_modal.like_changes'
            defaultMessage="If you would like changes to be made, you can message the host to request an update."
          />
        </p>
        <div className="cta-buttons">
          <CTAButton
            buttonText={ this.props.intl.formatMessage({ id: 'inbox_review_offer.confirm_decline_offer_modal.message_host', defaultMessage: 'Message Host' }) }
            onClickAction={this.handleMessageHostClick}
            classNameString="btn btn-primary form"
            isDisabled={false}
          />
          <CTAButton
            buttonText={ this.props.intl.formatMessage({ id: 'inbox_review_offer.confirm_decline_offer_modal.decline_offer_button', defaultMessage: 'Decline Offer' }) }
            onClickAction={this.handleDeclineOfferClick}
            classNameString="classic btn btn-gray-outline form margin-md-top"
            isDisabled={false}
          />
        </div>
      </div>
    );
  }

  render () {
    const { iosWebView, whichModal } = this.props;
    return (
      <div>
        {
          iosWebView && ('confirmDeclineOfferModal' === whichModal) ?
            <div id="confirm-decline-offer-modal" className="confirm-decline-offer-modal">
              <button className="btn-link remove-click-styling pull-right ico ico-sm icon-close-sidebar" onClick={this.closeModal} />
              <div className="text-center">
                <h4>
                  <FormattedMessage
                    id='inbox_review_offer.confirm_decline_offer_modal.decline_offer'
                    defaultMessage="Decline Offer"
                  />
                </h4>
              </div>
              {
                this.modalBody()
              }
            </div>
            :
            <BootstrapModal
              {...this.props}
              addCloseIcon
              show
              modalID="decline-offer-modal"
              modalSize="sm-size"
              modalType="standard"
              header={ <h4><FormattedMessage id='inbox_review_offer.confirm_decline_offer_modal.decline_offer_modal' defaultMessage="Decline Offer"/> </h4> }
              body={ this.modalBody() }
            />
        }
      </div>
    );
  }
}


ConfirmDeclineOfferModal.propTypes = {
  accessToken: PropTypes.string,
  bookingId: PropTypes.string,
  closeIOSModal: PropTypes.func,
  iosWebView: PropTypes.bool,
  toggleModal: PropTypes.func,
  scrollTopIOS: PropTypes.func,
  whichModal: PropTypes.string,
  intl: intlShape
};

ConfirmDeclineOfferModal.contextTypes = {
  router: PropTypes.object
};

exports.ConfirmDeclineOfferModal = injectIntl(ConfirmDeclineOfferModal);
